"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringConsts = require("01_core/constants/stringConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _KunrenInfoField = _interopRequireDefault(require("../../common/components/KunrenInfoField"));
var _Consts = require("../../common/consts/Consts");
var _ReportListTable = _interopRequireDefault(require("./ReportListTable"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const NAME_CELL_WIDTH = 130;
const NUM_CELL_WIDTH = 100;
const COLOR_GOOD = '#0000FF';
const COLOR_NORMAL = '#000000';
const COLOR_BAD = '#FF0000';
const NameCell = (0, _styles.styled)(_material.TableCell)({
  width: NAME_CELL_WIDTH,
  borderBottom: 'solid 1px',
  padding: 0
});
const NumCell = (0, _styles.styled)(_material.TableCell)({
  width: NUM_CELL_WIDTH,
  borderBottom: 'solid 1px',
  paddingRight: '3px'
});
const MetricText = (0, _styles.styled)(_material.Typography)({
  fontSize: 'small',
  fontWeight: 'bold',
  textAlign: 'right'
});
const NumTextDisp = (0, _styles.styled)('div')(_ref => {
  let {
    theme
  } = _ref;
  return {
    textAlign: 'right',
    marginRight: theme.spacing(2)
  };
});
const PreLineTypography = (0, _styles.styled)(_material.Typography)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    whiteSpace: 'pre-line',
    fontSize: theme.typography.body2.fontSize
  };
});

/**
 * 訓練実施報告登録結果・削除結果共通詳細部分
 */
class ReportCommonDetail extends _react.default.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "fontColor", num => {
      const val = Number(num);
      if (!isNaN(val) && val >= _Consts.CONSTS.GOOD_VAL) {
        return COLOR_GOOD;
      } else if (!isNaN(val) && val <= _Consts.CONSTS.NORMAL_VAL) {
        return COLOR_BAD;
      } else {
        return COLOR_NORMAL;
      }
    });
    _defineProperty(this, "selectValue", (list, key) => {
      let data = '';
      list.forEach(item => {
        if (item.value === key) {
          data = item.name;
        }
      });
      return data;
    });
    _defineProperty(this, "targetRiskList", () => {
      const {
        reportEntry
      } = this.props;
      let targetRiskList = [];
      reportEntry.checkStatusList.forEach((item, index) => {
        if (item.guidelineCd === _Consts.CONSTS.GUIDELINE_OTHER) {
          if (item.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_01 && item.activityFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1) {
            if (targetRiskList.length !== 0) {
              targetRiskList.push(_stringConsts.STRING_CONSTS.TOUTEN_ZENKAKU);
            }
            targetRiskList.push(item.notes);
          }
        } else {
          if (item.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_01 && item.activityFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1) {
            if (targetRiskList.length !== 0) {
              targetRiskList.push(_stringConsts.STRING_CONSTS.TOUTEN_ZENKAKU);
            }
            targetRiskList.push(item.contents);
          }
        }
      });
      if (targetRiskList.length === 0) {
        targetRiskList.push(/*#__PURE__*/_react.default.createElement(_material.Typography, {
          variant: "body2"
        }, _stringConsts.STRING_CONSTS.HYPHEN_ZENKAKU));
      } else {
        targetRiskList = /*#__PURE__*/_react.default.createElement(_material.Typography, {
          variant: "body2"
        }, targetRiskList);
      }
      return targetRiskList;
    });
    _defineProperty(this, "kunrenPeriodList", () => {
      const {
        reportEntry
      } = this.props;
      let kunrenPeriodList = [];
      reportEntry.checkStatusList.forEach((item, index) => {
        if (item.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_02 && item.activityFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1) {
          if (kunrenPeriodList.length !== 0) {
            kunrenPeriodList.push(_stringConsts.STRING_CONSTS.TOUTEN_ZENKAKU);
          }
          kunrenPeriodList.push(item.contents);
        }
      });
      if (kunrenPeriodList.length === 0) {
        kunrenPeriodList.push(/*#__PURE__*/_react.default.createElement(_material.Typography, {
          variant: "body2"
        }, _stringConsts.STRING_CONSTS.HYPHEN_ZENKAKU));
      } else {
        kunrenPeriodList = /*#__PURE__*/_react.default.createElement(_material.Typography, {
          variant: "body2"
        }, kunrenPeriodList);
      }
      return kunrenPeriodList;
    });
  }
  render() {
    const {
      intl,
      reportEntry,
      kunrenInfo
    } = this.props;
    const taskColumns = [{
      dataKey: 'bumon',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_TASK_BUMON
      }),
      width: 300
    }, {
      dataKey: 'kind',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_TASK_KIND
      }),
      width: 300
    }, {
      dataKey: 'taio',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_TASK_TAIO
      }),
      width: 300
    }, {
      dataKey: 'schedule',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_TASK_SCHEDULE
      }),
      width: 400
    }, {
      dataKey: 'task',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_TASK
      }),
      width: 900
    }];

    // 被監査部門表データ
    const createTaskRow = data => {
      const bumon = !(data.bumonList.length === 0) && /*#__PURE__*/_react.default.createElement(_material.Typography, {
        variant: "body2"
      }, _stringUtil.default.emptyToHyphen(this.selectValue(data.bumonList, data.bumon)));
      const kind = data.bumon && !(data.kindList.length === 0) && /*#__PURE__*/_react.default.createElement(_material.Typography, {
        variant: "body2"
      }, _stringUtil.default.emptyToHyphen(this.selectValue(data.kindList, data.kind)));
      const taio = data.kind && !(data.taioList.length === 0) && /*#__PURE__*/_react.default.createElement(_material.Typography, {
        variant: "body2"
      }, _stringUtil.default.emptyToHyphen(this.selectValue(data.taioList, data.taio)));
      const schedule = _stringUtil.default.emptyToHyphen(data.schedule);
      const task = _stringUtil.default.emptyToHyphen(data.task);
      return {
        bumon,
        kind,
        taio,
        schedule,
        task
      };
    };
    const reportResultColumns = [{
      dataKey: 'teamName',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_CHECKSHEET_TEAM_NM
      }),
      width: 700
    }, {
      dataKey: 'replyNum',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_CHECKSHEET_REPLY
      }),
      width: 100
    }, {
      dataKey: 'understand',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_CHECKSHEET_UNDERSTAND
      }),
      width: 100
    }, {
      dataKey: 'effect',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_CHECKSHEET_EFFECT
      }),
      width: 100
    }, {
      dataKey: 'teamComment',
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_CHECKSHEET_COMMENT
      }),
      width: 900
    }];

    // 被監査部門表データ
    const createReportResultRow = data => {
      const teamName = _stringUtil.default.emptyToHyphen(data.teamName);
      const replyNum = /*#__PURE__*/_react.default.createElement(NumTextDisp, null, _stringUtil.default.emptyToHyphen(data.replyNum));
      const understand = /*#__PURE__*/_react.default.createElement(NumTextDisp, null, _stringUtil.default.emptyToHyphen(data.understand));
      const effect = /*#__PURE__*/_react.default.createElement(NumTextDisp, null, _stringUtil.default.emptyToHyphen(data.effect));
      const teamComment = _stringUtil.default.emptyToHyphen(data.teamComment);
      return {
        teamName,
        replyNum,
        understand,
        effect,
        teamComment
      };
    };
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_KunrenInfoField.default, {
      data: kunrenInfo
    }), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_REPORT_JISSHI_DETAIL
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_JISSHI_DT
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(reportEntry.exercisesDt))), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_TGT_RISK
      }),
      indent: true
    }, this.targetRiskList()), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_TGT_RISK_DETAIL
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(PreLineTypography, null, _stringUtil.default.emptyToHyphen(reportEntry.riskDetailNotes))), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_PERIOD
      }),
      indent: true
    }, this.kunrenPeriodList()), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_PURPOSE
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(PreLineTypography, null, _stringUtil.default.emptyToHyphen(reportEntry.kunrenPurpose))), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_CONTENT
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(PreLineTypography, null, _stringUtil.default.emptyToHyphen(reportEntry.kunrenContent))), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_SUPPLEMENT
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(PreLineTypography, null, _stringUtil.default.emptyToHyphen(reportEntry.supplement))), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_PARTICIPANT
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(reportEntry.partcipant))), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_PARTICIPANT_LIST
      }),
      indent: true
    }, reportEntry.fileList.length === 0 ? _stringConsts.STRING_CONSTS.HYPHEN_ZENKAKU : reportEntry.fileList.map((item, index) => {
      return /*#__PURE__*/_react.default.createElement(_material.Typography, {
        variant: "body2",
        key: index
      }, item.fileNm);
    })), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_RESULT
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(PreLineTypography, null, _stringUtil.default.emptyToHyphen(reportEntry.kunrenResult)))), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_REPORT_TASK_TITLE
      }),
      indent: true
    }, reportEntry.repTaskList.length === 0 ? _stringConsts.STRING_CONSTS.HYPHEN_ZENKAKU : /*#__PURE__*/_react.default.createElement(_ReportListTable.default, {
      rowData: reportEntry.repTaskList,
      columns: taskColumns,
      createRow: createTaskRow,
      listType: 'TASK_RESULT'
    })), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_REPORT_CHECKSHEET_RESULT
      }),
      indent: true
    }, reportEntry.reportResultList.length === 0 ? _stringConsts.STRING_CONSTS.HYPHEN_ZENKAKU : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_ReportListTable.default, {
      rowData: reportEntry.reportResultList,
      columns: reportResultColumns,
      createRow: createReportResultRow
    }), /*#__PURE__*/_react.default.createElement(_material.Table, null, /*#__PURE__*/_react.default.createElement(_material.TableBody, null, /*#__PURE__*/_react.default.createElement(_material.TableRow, null, /*#__PURE__*/_react.default.createElement(_material.TableCell, {
      style: {
        width: 800
      }
    }), /*#__PURE__*/_react.default.createElement(NameCell, null, /*#__PURE__*/_react.default.createElement(MetricText, null, intl.formatMessage({
      id: _labelConsts.LABEL.BCM_KUNREN_CHECKSHEET_AVERAGE
    }))), /*#__PURE__*/_react.default.createElement(NumCell, null, /*#__PURE__*/_react.default.createElement(MetricText, {
      style: {
        color: this.fontColor(reportEntry.reportResultAverage.understand)
      }
    }, reportEntry.reportResultAverage.understand)), /*#__PURE__*/_react.default.createElement(NumCell, null, /*#__PURE__*/_react.default.createElement(MetricText, {
      style: {
        color: this.fontColor(reportEntry.reportResultAverage.effect)
      }
    }, reportEntry.reportResultAverage.effect)), /*#__PURE__*/_react.default.createElement(_material.TableCell, {
      style: {
        width: 950,
        maxWidth: 1100
      }
    })))))), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_REPORT_COMMENT_TITLE
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_EVALUATION
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(PreLineTypography, null, _stringUtil.default.emptyToHyphen(reportEntry.kunrenEvaluation))), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_EVALUATION_COMMENT
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(PreLineTypography, null, _stringUtil.default.emptyToHyphen(reportEntry.hqComments)))));
  }
}
var _default = exports.default = (0, _reactIntl.injectIntl)(ReportCommonDetail);